import React, { useEffect, useState, useMemo } from "react";
import { Global } from "../helpers/Global";

export const LogsAdmin = () => {
    const [logs, setLogs] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [filtroUsuario, setFiltroUsuario] = useState("");
    const [filtroEntidad, setFiltroEntidad] = useState("");
    const [mensaje, setMensaje] = useState("");

    useEffect(() => {
        fetchLogs();
        fetchUsuarios();
    }, []);

    const fetchLogs = async () => {
        try {
            const res = await fetch(`${Global.url}usuarios/admin/logs`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            });
            if (res.ok) {
                const data = await res.json();
                setLogs(data);
            } else {
                setMensaje("No se pudieron obtener los logs");
            }
        } catch (error) {
            console.error("Error:", error);
            setMensaje("Error de conexión con el servidor.");
        }
    };

    const fetchUsuarios = async () => {
        try {
            const res = await fetch(`${Global.url}usuarios`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            });
            if (res.ok) setUsuarios(await res.json());
        } catch (err) {
            console.error("Error al obtener usuarios:", err);
        }
    };

    const logsFiltrados = useMemo(() => {
        return logs.filter((log) => {
            const matchUsuario = !filtroUsuario || log.admin_id?.toString() === filtroUsuario;
            const matchEntidad = !filtroEntidad || log.entidad?.toLowerCase().includes(filtroEntidad.toLowerCase());
            return matchUsuario && matchEntidad;
        });
    }, [logs, filtroUsuario, filtroEntidad]);

    const obtenerNombreAdmin = (id) => {
        const admin = usuarios.find((u) => u.id === id);
        return admin ? admin.nombre : `ID: ${id}`;
    };

    const obtenerNombreEntidad = (entidad, entidad_id) => {
        return entidad_id ? `${entidad} (${entidad_id})` : entidad;
    };

    return (
        <div className="consulta-ticajes">
            <h2 className="centrar-titulo">Actividad de Administradores</h2>
            {mensaje && <p className="rojo">{mensaje}</p>}

            <div className="filtros">
                <label>Administrador:</label>
                <select value={filtroUsuario} onChange={(e) => setFiltroUsuario(e.target.value)}>
                    <option value="">Todos</option>
                    {usuarios.map((u) => (
                        <option key={u.id} value={u.id}>{u.nombre}</option>
                    ))}
                </select>

                <label>Entidad:</label>
                <input type="text" value={filtroEntidad} onChange={(e) => setFiltroEntidad(e.target.value)} placeholder="Entidad (ej: usuario)" />
            </div>
            <div className="table-listado-padre">
                <table className="table-listado logs">
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Administrador</th>
                            <th>Acción</th>
                            <th>Entidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        {logsFiltrados.map((log) => (
                            <tr key={log.id}>
                                <td>{new Date(log.fecha).toLocaleString()}</td>
                                <td>{log.admin_nombre}</td>
                                <td>{log.accion}</td>
                                <td>{log.entidad} ({log.entidad_nombre || `ID: ${log.entidad_id}`})</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
